import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("App error boundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#2C3539] text-white flex items-center justify-center px-6" data-testid="error-boundary">
          <div className="max-w-lg text-center">
            <div className="font-display text-5xl uppercase">Something broke on our end.</div>
            <p className="mt-4 text-white/75">Sorry about that — a quick refresh usually fixes it.</p>
            <button
              onClick={() => window.location.reload()}
              data-testid="error-reload-btn"
              className="mt-8 bg-[#2F5F80] hover:bg-[#234B66] text-white text-sm font-bold tracking-[0.15em] px-8 py-4 uppercase transition-colors"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
